import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectUserFacilities } from '../../../redux/slices/facilitiesSlice';
import { facilityBrandingService } from '../../../services/facilityBrandingService';

export const useFacilityBranding = (user) => {
  const userFacilities = useSelector(selectUserFacilities);
  const [branding, setBranding] = useState({ logoUrl: '', primaryColor: '#1976d2' });

  const fetchFacilityBranding = useCallback(async () => {
    if (!user) return;
    try {
      // Use Redux for user facilities
      if (userFacilities && userFacilities.length > 0) {
        const facilityId = userFacilities[0].facilityId;
        if (facilityId) {
          try {
            const facilityBranding = await facilityBrandingService.getFacilityBranding(facilityId);
            if (facilityBranding && facilityBranding.branding) {
              setBranding(facilityBranding.branding);
            }
          } catch (error) {
            console.error("Error fetching facility branding:", error);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching facility branding:", error);
    }
  }, [user, userFacilities]);

  useEffect(() => {
    fetchFacilityBranding();
  }, [fetchFacilityBranding]);

  return { branding };
}; 